import QRCode from 'qrcode.react';
import React, { useRef } from 'react';
import {
  ArrowLeftIcon,
  ArrowDownTrayIcon,
  ArrowTopRightOnSquareIcon,
} from '@heroicons/react/24/outline';
import Button from '@dashboard/components/Button';
import downloadUrlAsFile from '@dashboard/services/downloadUrlAsFile';
import getCheckoutUrl from '@dashboard/services/getCheckoutUrl';

const QRCodeOverlay = ({ page, seller, onBack }) => {
  const largeQrParentRef = useRef(null);
  const pageUrlId = page.slug;
  const checkoutUrl = getCheckoutUrl(page, seller);
  const qrUrl = `${checkoutUrl}/qr`;

  const downloadQrCode = () => {
    const qrCodeUrl = largeQrParentRef?.current?.firstChild
      ?.toDataURL('image/png')
      .replace('image/png', 'image/octet-stream');

    downloadUrlAsFile(qrCodeUrl, pageUrlId + '-qrcode.png');
  };

  return (
    <div className="text-left h-full flex-1 flex flex-col">
      <div className="flex items-center gap-3 mb-6">
        <button
          type="button"
          onClick={onBack}
          className="p-1 rounded hover:bg-gray-100 dark:hover:bg-muted transition-colors outline-none focus-visible:ring-2 focus-visible:ring-gray-950 dark:focus-visible:ring-ring focus-visible:ring-offset-2"
          aria-label="Go back"
        >
          <ArrowLeftIcon className="h-5 w-5 text-gray-700 dark:text-muted-foreground" />
        </button>
        <h2 className="text-lg font-bold">QR code</h2>
      </div>

      <div className="flex flex-col items-center">
        <div className="rounded bg-white p-4">
          <QRCode value={checkoutUrl} size={200} />
        </div>

        {/* Hidden large QR code for downloading */}
        <div
          style={{ visibility: 'hidden', display: 'none', position: 'absolute', top: 0, left: 0 }}
          ref={largeQrParentRef}
        >
          <QRCode value={checkoutUrl} size={1800} />
        </div>

        <div className="flex justify-center w-full mt-4 gap-4">
          <Button appearance="secondary" onClick={downloadQrCode}>
            <ArrowDownTrayIcon className="h-4 w-4" />
            Download
          </Button>

          <Button to={qrUrl} target="_blank" appearance="secondary">
            <ArrowTopRightOnSquareIcon className="h-4 w-4" />
            Open in new tab
          </Button>
        </div>
      </div>
    </div>
  );
};

export default QRCodeOverlay;
